import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
export const TYPE_TO_BI_CARD_NAME_MAPPING = {
  [VIDEO_CARD_TYPES.SOCIAL]: 'get_social_followers',
  [VIDEO_CARD_TYPES.PRODUCT]: 'boost_sales',
  [VIDEO_CARD_TYPES.CUSTOM]: 'custom',
  [VIDEO_CARD_TYPES.VIDEO]: 'promote_video',
  [VIDEO_CARD_TYPES.RECENT_VIDEO]: 'promote_video',
  [VIDEO_CARD_TYPES.CHANNEL]: 'feature_channel'
};
export function getBiVideoCardName(_ref) {
  let {
    type
  } = _ref;
  return TYPE_TO_BI_CARD_NAME_MAPPING[type];
}
//# sourceMappingURL=get-bi-video-card-name.js.map